import { ReactComponent as WarningIcon } from 'images/icons/WarningSign.svg';
import { cancelPrompt, selectMessagePrompt } from 'store/messagePromptSlice';
import { useDispatch, useSelector } from 'react-redux';
import { closeFloatingTicketPanel } from 'store/floatingTicketPanelSlice';
import useTexts from './useTexts';
import MessagePrompt from '.';

export default function MessagePromptWrapper() {
  const dispatch = useDispatch();
  const { titleText, descriptionText, btnOkText, btnCancelText } = useTexts();
  const prompt = useSelector(selectMessagePrompt);

  const onCancelClicked = () => {
    dispatch(cancelPrompt());
  };
  const onOkClick = () => {
    switch (prompt.onClickFunctionName) {
      case closeFloatingTicketPanel.toString():
        dispatch(closeFloatingTicketPanel(prompt?.url));
        onCancelClicked();
        break;
      default:
        dispatch(cancelPrompt());
        break;
    }
  };

  return (
    <>
      {prompt && (
        <MessagePrompt
          open
          title={prompt?.title || titleText}
          Icon={WarningIcon}
          btnOkText={prompt?.btnOkText || btnOkText}
          btnCancelText={prompt?.btnCancelText || btnCancelText}
          onOkClick={onOkClick}
          showCancelBtn={typeof prompt.showCancelBtn === 'undefined' ? true : prompt.showCancelBtn}
          onClose={onCancelClicked}
        >
          {prompt?.descriptionText || descriptionText}
        </MessagePrompt>
      )}
    </>
  );
}
